import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Schedule.css';

const scheduleData = {
  Monday: [
    { time: '6:00 AM', class: 'Hatha Yoga' },
    { time: '7:30 AM', class: 'Meditation' },
    { time: '6:00 PM', class: 'Vinyasa Flow' }
  ],
  Tuesday: [
    { time: '6:00 AM', class: 'Power Yoga' },
    { time: '7:30 AM', class: 'Breathing Practice' },
    { time: '6:00 PM', class: 'Yin Yoga' }
  ],
  Wednesday: [
    { time: '6:00 AM', class: 'Hatha Yoga' },
    { time: '7:30 AM', class: 'Meditation' },
    { time: '6:00 PM', class: 'Private Session' }
  ],
  Thursday: [
    { time: '6:00 AM', class: 'Sunrise Yoga' },
    { time: '7:30 AM', class: 'Mindfulness' },
    { time: '6:00 PM', class: 'Vinyasa Flow' }
  ],
  Friday: [
    { time: '6:00 AM', class: 'Power Yoga' },
    { time: '7:30 AM', class: 'Meditation' },
    { time: '6:00 PM', class: 'Restorative Yoga' }
  ],
  Saturday: [
    { time: '7:00 AM', class: 'Family Yoga' },
    { time: '8:30 AM', class: 'Kids Yoga' },
    { time: '5:00 PM', class: 'Group Session' }
  ],
  Sunday: [
    { special: 'Special Wellness Workshop', time: '9:00 AM – 11:00 AM' }
  ]
};

const days = Object.keys(scheduleData);

const Schedule = () => {
  const [activeDay, setActiveDay] = useState('Monday');

  return (
    <section className="schedule">
      <div className="schedule-container">
        
        <motion.div 
          className="schedule-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <h4 className="schedule-subtitle">WEEKLY SCHEDULE</h4>
          <h2 className="schedule-title">Practice at Your Convenience</h2>
          <p className="schedule-desc">
            Morning and evening classes designed to fit your daily routine.
          </p>
          <div className="schedule-divider"></div>
        </motion.div>

        <div className="schedule-content">
          <motion.div 
            className="schedule-tabs"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            {days.map((day) => (
              <button 
                key={day} 
                className={`tab-btn ${activeDay === day ? 'active' : ''}`}
                onClick={() => setActiveDay(day)}
              >
                {day.substring(0, 3).toUpperCase()}
              </button>
            ))}
          </motion.div>

          <motion.div 
            className="schedule-list-wrapper"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <AnimatePresence mode="wait">
              <motion.div
                key={activeDay}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}
                className="schedule-list"
              >
                <div className="day-title">{activeDay}</div>
                
                {activeDay === 'Sunday' ? (
                  <div className="schedule-row special-workshop">
                    <div className="schedule-time">{scheduleData['Sunday'][0].time}</div>
                    <div className="schedule-class-name">
                      {scheduleData['Sunday'][0].special}
                      <span className="badge">Special</span>
                    </div>
                    <button className="book-inline-btn">Reserve Spot</button>
                  </div>
                ) : (
                  scheduleData[activeDay].map((item, index) => (
                    <div key={index} className="schedule-row">
                      <div className="schedule-time">{item.time}</div>
                      <div className="schedule-class-name">{item.class}</div>
                      <button className="book-inline-btn">Book Now</button>
                    </div>
                  ))
                )}
              </motion.div>
            </AnimatePresence>
          </motion.div>
        </div>

      </div>
    </section>
  );
};

export default Schedule;
